export type DocType =
  | 'tc'
  | 'privacy'
  | 'imprint'
  | 'support'
  | 'faq'
  | 'additional-tc'
  | 'shop-additional-tc'
  | 'shop-additional-tc-contractor'
  | 'second-layer'
  | 'x-connect';

// Per-doc-type behaviour:
//  - DocBehavior.Default  → /docs/{type}/{locale}.html (prefix ignored)
//  - DocBehavior.Override → /docs/{prefix}{type}/{locale}.html, no fallback
// Omitting a doc type from `types` is equivalent to DocBehavior.Default.
export enum DocBehavior {
  Default = 'default',
  Override = 'override',
}

export type WhitelabelDocsConfig = {
  prefix: string;
  types: Partial<Record<DocType, DocBehavior>>;
};
